var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 5.06657C2.87707 5.06657 2.50016 5.44347 2.50016 5.8999V15.8999C2.50016 16.3563 2.87707 16.7332 3.3335 16.7332H16.6668C17.1233 16.7332 17.5002 16.3563 17.5002 15.8999V5.8999C17.5002 5.44347 17.1233 5.06657 16.6668 5.06657H3.3335ZM0.833496 5.8999C0.833496 4.523 1.95659 3.3999 3.3335 3.3999H16.6668C18.0437 3.3999 19.1668 4.523 19.1668 5.8999V15.8999C19.1668 17.2768 18.0437 18.3999 16.6668 18.3999H3.3335C1.95659 18.3999 0.833496 17.2768 0.833496 15.8999V5.8999Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.984208 5.42193C1.24814 5.04488 1.76775 4.95319 2.14479 5.21712L10.0002 10.7159L17.8557 5.21712C18.2327 4.95319 18.7523 5.04488 19.0163 5.42193C19.2802 5.79897 19.1885 6.31858 18.8115 6.5825L10.4781 12.4158C10.1912 12.6167 9.80928 12.6167 9.52235 12.4158L1.18902 6.5825C0.811975 6.31858 0.720279 5.79897 0.984208 5.42193Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/message.f3e86d4c886084472e74157ea514344a.svg";